import { Dispatch } from 'react';
import { handleError } from 'src/contexts/utils/handleError';
import { SET_LOADING } from 'src/contexts/types';
import { TContactActionTypes, TContactInitialState } from '../types';
import { CLEAR_CONTACT } from '../constants';

export const clearContact = (
    dispatch: Dispatch<TContactActionTypes>,
    body: Partial<TContactInitialState>
): void => {
    dispatch({ type: SET_LOADING });

    try {
        dispatch({
            type: CLEAR_CONTACT,
            payload: body,
        });
    } catch (error) {
        if (error instanceof Error) dispatch(handleError(error));
    }
};
